<template>
    <span class="c2b-loading">
        <fa icon="sync-alt" spin class="c2b-loading-icon"></fa>
        <span v-if="!!message" class="c2b-loading-message">{{message}}</span>
    </span>    
</template>

<script>
export default {
    name: 'LoadingCmp',
    props: {
        message: {
            type: String,
            default: '',
        },
    },
}
</script>

<style lang="scss" scoped>
.btn-primary {
    .c2b-loading {
        color: #fff;
    }
}

.c2b-loading {
    margin: 0 auto;
    color: #333;

    .c2b-loading-message {
        margin-left: 15px;
    }
}
</style>
